import AddCreditCardModal from './AddCreditCardModal';

export default {
  AddCreditCardModal,
};
